import { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";

function AddPurchase() {
    const [ldata, setLdata] = useState(null);
    const [items, setItems] = useState([]);

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const hasFetched = useRef(false);
    const today = new Date().toISOString().split("T")[0];

    const [formData, setFormData] = useState({
        medicines: [],
        store_purchase_type: 'normal',
        store_purchase_id: '',
        store_purchase_no: '',
        store_purchase_date: today,
        store_purchase_mode: '',
        store_invoice_number: '',
        store_invoice_date: today,
        store_purchase_vendor: '',
        store_purchase_total: '',
        store_purchase_gtotal: '',
        store_purchase_dis: '',
        store_purchase_gst: '',
        store_purchase_user: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleChange1 = (e, index) => {
        if (!e || !e.target) return;
        const { name, value } = e.target;
        const name1 = name.replace(/[0-9]/g, "");

        setFormData((prev) => {
            const updatedItems = [...prev.medicines];
            let newValue = value;

            if (name1 === "store_purchase_item_qty") {
                newValue = Math.max(1, Number(value) || 1);
            }

            updatedItems[index] = {
                ...updatedItems[index],
                [name1]: newValue,
            };

            const rate = parseFloat(updatedItems[index].store_purchase_item_rate) || 0;
            const qty = parseFloat(updatedItems[index].store_purchase_item_qty) || 0;
            const disPer = parseFloat(updatedItems[index].store_purchase_item_dis) || 0;
            const gst = parseFloat(updatedItems[index].store_purchase_item_gst) || 0;

            const rowTotal = rate * qty;
            const itemdisPrice = (rate * disPer) / 100;
            const rowDisAmt = (rowTotal * disPer) / 100;
            const rowFinal = rowTotal - rowDisAmt;
            const rowGstAmt = (rowFinal * gst) / 100;
            const itemTotalPrice = rate - itemdisPrice;

            updatedItems[index].store_purchase_item_dis_amt = itemdisPrice.toFixed(2);
            updatedItems[index].store_purchase_item_total = itemTotalPrice.toFixed(2);

            let totalAmt = 0;
            let totalDis = 0;
            let grandTotal = 0;
            let totalGst = 0;

            updatedItems.forEach((itm) => {
                const r = parseFloat(itm.store_purchase_item_rate) || 0;
                const q = parseFloat(itm.store_purchase_item_qty) || 0;
                const dP = parseFloat(itm.store_purchase_item_dis) || 0;
                const g = parseFloat(itm.store_purchase_item_gst) || 0;

                const t = r * q;
                const dA = (t * dP) / 100;
                const fA = t - dA;
                const gA = (fA * g) / 100;

                totalAmt += t;
                totalDis += dA;
                grandTotal += fA;
                totalGst += gA;
            });

            return {
                ...prev,
                medicines: updatedItems,
                store_purchase_total: totalAmt.toFixed(2),
                store_purchase_dis: totalDis.toFixed(2),
                store_purchase_gtotal: grandTotal.toFixed(2),
                store_purchase_gst: totalGst.toFixed(2),
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.store_purchase_vendor) {
            toast.error("Please select a supplier!");
            return;
        }
        if (formData.medicines.length === 0) {
            toast.error("Please add at least one item!");
            return;
        }
        if (!formData.store_purchase_date) {
            toast.error("Please select purchase date!");
            return;
        }
        if (!formData.store_purchase_mode) {
            toast.error("Please select payment mode!");
            return;
        }

        const fd = new FormData();
        fd.append('store_purchase_id', formData.store_purchase_id);
        fd.append('store_purchase_no', formData.store_purchase_no);
        fd.append('store_purchase_type', formData.store_purchase_type);
        fd.append('store_purchase_date', formData.store_purchase_date);
        fd.append('store_purchase_mode', formData.store_purchase_mode);
        fd.append('store_invoice_number', formData.store_invoice_number);
        fd.append('store_invoice_date', formData.store_invoice_date);
        fd.append('store_purchase_vendor', formData.store_purchase_vendor);
        fd.append('store_purchase_total', formData.store_purchase_total);
        fd.append('store_purchase_dis', formData.store_purchase_dis);
        fd.append('store_purchase_gst', formData.store_purchase_gst);
        fd.append('store_purchase_gtotal', formData.store_purchase_gtotal);
        fd.append('store_items', JSON.stringify(formData.medicines));
        fd.append('store_purchase_user', ldata.user_id);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addStorePurchaseUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (response.data.status) {
                toast.success(response.data.success || "Purchase saved successfully!");
                sessionStorage.removeItem("opd_dt");
                setTimeout(() => {
                    window.location.href = "/store_purchase";
                }, 1500);
            } else {
                toast.error(response.data.success || "Failed to save purchase");
            }
        } catch (error) {
            console.error("Error saving purchase:", error);
            toast.error("Failed to save purchase. Please try again.");
        }
    };

    const fetchNextPurchaseNo = async () => {
        try {
            const res = await axios.get(AppConst.BASE_URL + AppConst.getNextPurchaseNoUrl);
            if (res.data.status) {
                setFormData(prev => ({ ...prev, store_purchase_no: res.data.next_no }));
            }
        } catch (err) {
            console.error("Error fetching next purchase no:", err);
            setFormData(prev => ({ ...prev, store_purchase_no: Date.now().toString().slice(-6) }));
        }
    };

    const fetchSuppliers = async () => {
        const fd = new FormData();
        fd.append('type', "supplier1");
        fd.append('search_key', '');
        fd.append('page_no', 'none');
        fd.append('user_cre_by', 1);

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status) {
                const records = response.data.records || [];
                return records.map(sup => ({
                    value: sup.user_id,
                    label: `${sup.fname} ${sup.lname || ''}`.trim(),
                    data: sup
                }));
            }
        } catch (error) {
            console.error("Error fetching suppliers:", error);
        }
        return [];
    };

    const fetchItems = async () => {
        try {
            const res = await axios.get(AppConst.BASE_URL + AppConst.getStoreItemsUrl);
            if (res.data.status) {
                const itemsData = res.data.records || res.data.data || [];
                setItems(itemsData);
                setItemOptions(itemsData.map(item => ({
                    value: item.id || item.store_item_id,
                    label: `${item.store_hsn || ''} - ${item.store_item_name} (${item.store_unit || ''})`,
                    data: item
                })));
            }
        } catch (err) {
            console.error("Item fetch error:", err);
        }
    };

    const handleItemSelect = (selected) => {
        if (!selected) { setSelectedItem(null); return; }
        const item = selected.data;

        setFormData((prev) => ({
            ...prev,
            medicines: [
                ...prev.medicines,
                {
                    store_purchase_item_name: item.store_item_name,
                    store_purchase_item_unit: item.store_unit,
                    store_purchase_item_rate: 0,
                    store_purchase_item_qty: 1,
                    store_batch_no: '',
                    store_purchase_item_dis: 0,
                    store_purchase_item_dis_amt: 0,
                    store_purchase_item_gst: item.store_igst || 0,
                    store_purchase_item_total: 0,
                    store_purchase_item_MRP: 0,
                    store_department: item.store_department,
                    store_hsn: item.store_hsn,
                },
            ],
        }));

        setSelectedItem(null);
        toast.success(`${item.store_item_name} added to purchase`);
    };

    const handleRemoveItem = (index) => {
        setFormData((prev) => {
            const updatedItems = prev.medicines.filter((_, i) => i !== index);

            let totalAmt = 0, totalDis = 0, grandTotal = 0, totalGst = 0;
            updatedItems.forEach((itm) => {
                const r = parseFloat(itm.store_purchase_item_rate) || 0;
                const q = parseFloat(itm.store_purchase_item_qty) || 0;
                const dP = parseFloat(itm.store_purchase_item_dis) || 0;
                const g = parseFloat(itm.store_purchase_item_gst) || 0;
                const t = r * q;
                const dA = (t * dP) / 100;
                const fA = t - dA;
                const gA = (fA * g) / 100;
                totalAmt += t; totalDis += dA; grandTotal += fA; totalGst += gA;
            });

            return {
                ...prev,
                medicines: updatedItems,
                store_purchase_total: totalAmt.toFixed(2),
                store_purchase_dis: totalDis.toFixed(2),
                store_purchase_gtotal: grandTotal.toFixed(2),
                store_purchase_gst: totalGst.toFixed(2),
            };
        });
    };

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        const storedData = sessionStorage.getItem("ldata");
        if (!storedData) return;

        const parsed = JSON.parse(storedData);
        setLdata(parsed);

        const init = async () => {
            const [supplierOpts] = await Promise.all([
                fetchSuppliers(),
                fetchItems(),
                fetchNextPurchaseNo(),
            ]);

            if (supplierOpts && supplierOpts.length > 0) {
                setSupplierOptions(supplierOpts);
            }

            const editData = sessionStorage.getItem("opd_dt");
            if (editData) {
                const tmp = JSON.parse(editData);
                const mappedItems = (tmp.items || []).map(item => ({
                    ...item,
                    store_batch_no: item.store_purchase_item_batch_no || item.store_batch_no || '',
                    store_department: item.store_purchase_item_department || item.store_department || '',
                    store_hsn: item.store_purchase_item_hsn || item.store_hsn || '',
                    store_purchase_item_MRP: item.store_purchase_item_MRP || 0,
                }));

                setFormData(prev => ({
                    ...prev,
                    medicines: mappedItems,
                    store_purchase_id: tmp.store_purchase_id,
                    store_purchase_no: tmp.store_purchase_no || prev.store_purchase_no,
                    store_purchase_type: tmp.store_purchase_type,
                    store_purchase_date: tmp.store_purchase_date,
                    store_purchase_mode: tmp.store_purchase_mode,
                    store_invoice_number: tmp.store_invoice_number,
                    store_invoice_date: tmp.store_invoice_date,
                    store_purchase_vendor: tmp.store_purchase_vendor,
                    store_purchase_total: tmp.store_purchase_total,
                    store_purchase_dis: tmp.store_purchase_dis,
                    store_purchase_gst: tmp.store_purchase_gst,
                    store_purchase_gtotal: tmp.store_purchase_gtotal,
                }));

                if (tmp.store_purchase_vendor && supplierOpts) {
                    const supplier = supplierOpts.find(opt => opt.value == tmp.store_purchase_vendor);
                    if (supplier) setSelectedSupplier(supplier);
                }
            }
        };

        init();
    }, []);

    const selectStyles = {
        control: (base) => ({ ...base, minHeight: '38px', borderColor: '#ced4da' }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12">
                        <div className="card">
                            <div className="card-body">
                                <h5>
                                    {formData.store_purchase_id ? 'Edit Purchase' : 'New Purchase'}
                                    <span className="badge bg-info ms-2">From Supplier</span>
                                </h5>
                                <br />
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-label">Purchase No.</label>
                                            <input name="store_purchase_no" value={formData.store_purchase_no} className="form-control" type="text" readOnly style={{ background: "#eee" }} />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Purchase Date <span className="text-danger">*</span></label>
                                            <input name="store_purchase_date" onChange={handleChange} value={formData.store_purchase_date} className="form-control" type="date" required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Payment Mode <span className="text-danger">*</span></label>
                                            <select className="form-control" name="store_purchase_mode" onChange={handleChange} value={formData.store_purchase_mode} required>
                                                <option value="">Select</option>
                                                <option value="Cash">Cash</option>
                                                <option value="Online">Online</option>
                                                <option value="Card">Card</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Invoice Number</label>
                                            <input name="store_invoice_number" onChange={handleChange} value={formData.store_invoice_number} className="form-control" type="text" required />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Invoice Date</label>
                                            <input name="store_invoice_date" onChange={handleChange} value={formData.store_invoice_date} className="form-control" type="date" />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Select Supplier <span className="text-danger">*</span></label>
                                            <Select
                                                options={supplierOptions}
                                                value={selectedSupplier}
                                                onChange={(selected) => {
                                                    setSelectedSupplier(selected);
                                                    setFormData(prev => ({ ...prev, store_purchase_vendor: selected ? selected.value : "" }));
                                                }}
                                                isClearable placeholder="Select Supplier" styles={selectStyles}
                                            />
                                        </div>

                                        <div className="col-12 mt-3">
                                            <label className="form-label"><i className="ri-barcode-line me-2"></i>Select Item to Add</label>
                                            <Select
                                                options={itemOptions} value={selectedItem} onChange={handleItemSelect}
                                                isClearable placeholder="Search by HSN, Item name, or Unit..."
                                                styles={selectStyles} noOptionsMessage={() => "No items found"}
                                            />
                                        </div>

                                        {/* Items Table */}
                                        <div className="col-12 mt-3">
                                            <h6>Items</h6>
                                            <div className="table-responsive">
                                                <table className="table table-bordered">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Sr.</th>
                                                            <th>Item Name</th>
                                                            <th>Unit</th>
                                                            <th>QTY</th>
                                                            <th>Batch No</th>
                                                            <th>Rate</th>
                                                            <th>MRP</th>
                                                            <th>Dis %</th>
                                                            <th>Dis Amt</th>
                                                            <th>Gst %</th>
                                                            <th>Total</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {formData.medicines.length > 0 ? (
                                                            formData.medicines.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.store_purchase_item_name} readOnly style={{ background: "#EEE" }} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.store_purchase_item_unit} readOnly style={{ background: "#EEE" }} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" name={`store_purchase_item_qty${index}`} value={item.store_purchase_item_qty} min={1} onChange={(e) => handleChange1(e, index)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" name={`store_batch_no${index}`} value={item.store_batch_no || ''} placeholder="Batch No" onChange={(e) => handleChange1(e, index)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" name={`store_purchase_item_rate${index}`} value={item.store_purchase_item_rate} onChange={(e) => handleChange1(e, index)} />
                                                                    </td>
                                                                    {/* MRP — editable, saves to store_purchase_item_MRP */}
                                                                    <td>
                                                                        <input type="number" className="form-control" name={`store_purchase_item_MRP${index}`} value={item.store_purchase_item_MRP || ''} placeholder="MRP" onChange={(e) => handleChange1(e, index)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control" name={`store_purchase_item_dis${index}`} value={item.store_purchase_item_dis} onChange={(e) => handleChange1(e, index)} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.store_purchase_item_dis_amt} readOnly style={{ background: "#EEE" }} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.store_purchase_item_gst} readOnly style={{ background: "#EEE" }} />
                                                                    </td>
                                                                    <td>
                                                                        <input type="text" className="form-control" value={item.store_purchase_item_total} readOnly style={{ background: "#EEE" }} />
                                                                    </td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-sm btn-danger" onClick={() => handleRemoveItem(index)}>
                                                                            <i className="ri-delete-bin-line"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="12" className="text-center text-muted">No items selected yet</td>
                                                            </tr>
                                                        )}

                                                        {formData.medicines.length > 0 && (
                                                            <>
                                                                <tr>
                                                                    <td colSpan="7"></td>
                                                                    <td><strong>Total</strong></td>
                                                                    <td><strong>Discount</strong></td>
                                                                    <td><strong>Final Amt</strong></td>
                                                                    <td><strong>Gst Amt</strong></td>
                                                                    <td></td>
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan="7"></td>
                                                                    <td><input type="text" className="form-control" value={formData.store_purchase_total} readOnly style={{ background: "#EEE", fontWeight: "bold" }} /></td>
                                                                    <td><input type="text" className="form-control" value={formData.store_purchase_dis} readOnly style={{ background: "#EEE", fontWeight: "bold" }} /></td>
                                                                    <td><input type="text" className="form-control" value={formData.store_purchase_gtotal} readOnly style={{ background: "#EEE", fontWeight: "bold" }} /></td>
                                                                    <td><input type="text" className="form-control" value={formData.store_purchase_gst} readOnly style={{ background: "#EEE", fontWeight: "bold" }} /></td>
                                                                    <td></td>
                                                                </tr>
                                                            </>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="col-12">
                                            <div className="text-end">
                                                <button type="button" className="btn btn-secondary me-2"
                                                    onClick={() => { if (window.confirm("Cancel and go back?")) { sessionStorage.removeItem("opd_dt"); window.location.href = "/store_purchase"; } }}>
                                                    Cancel
                                                </button>
                                                <button type="submit" className="btn btn-primary">
                                                    <i className="ri-save-line me-1"></i> Save Purchase
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AddPurchase;